import { SelectTabData, SelectTabEvent, Tab, TabList, TabValue } from "@fluentui/react-components";
import IPasswordFormProps from "../IPasswordFormProps";
import { useTranslation } from "react-i18next";
import useStyleUtils from "../../../utilities/styles";

interface IPasswordFormTabsProps extends IPasswordFormProps {
    selectedTab: TabValue;
    onTabChange: (tab: string) => void;
}

export default function Tabs(props: IPasswordFormTabsProps) {
    const { t } = useTranslation();

    const style = useStyleUtils();

    const handleTabSelect = (_: SelectTabEvent, data: SelectTabData) => props.onTabChange(data.value as string);

    return (
        <TabList selectedValue={props.selectedTab} onTabSelect={handleTabSelect} className={style.mb3}>
            <Tab value="tab-details">
                {t("passwords.form.sections.details")}
            </Tab>
            <Tab value="tab-mfa">
                {t("passwords.form.sections.mfa")}
            </Tab>
            <Tab value="tab-audience">
                {t("passwords.form.sections.audience")}
            </Tab>
            <Tab value="tab-attributes">
                {t("passwords.form.sections.attributes")}
            </Tab>
        </TabList>
    );
}